import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDotGrid2x3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"dot-grid-2x3, menu, drag, grab"} maskId="square-filled-radius-0-stroke-1-IconDotGrid2x3"><path d="M8 4H11V7H8V4Z" fill="currentColor"/><path d="M8 17H11V20H8V17Z" fill="currentColor"/><path d="M8 10.5H11V13.5H8V10.5Z" fill="currentColor"/><path d="M13 4H16V7H13V4Z" fill="currentColor"/><path d="M13 17H16V20H13V17Z" fill="currentColor"/><path d="M13 10.5H16V13.5H13V10.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDotGrid2x3;
